import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import { useContext, useEffect, useRef, useState } from 'react'
import { ICustomer } from '../../../../../../../../app/entities/Customer'
import { ICustomerVehicle } from '../../../../../../../../app/entities/CustomerVehicle'
import { IInstallationPoint } from '../../../../../../../../app/entities/InstallationPoint'
import { IOrder } from '../../../../../../../../app/entities/Order'
import { ITiresCombination } from '../../../../../../../../app/entities/TiresCombination'
import PrimaryButton from '../../../../../../global/components/buttons/primary-button/PrimaryButton'
import SecondaryButton from '../../../../../../global/components/buttons/secondary-button/SecondaryButton'
import { MODES } from '../../../../../../global/constants/scheduler'
import { fetchData } from '../../../../../../global/helper-functions/fetch'
import { AppointmentSlots } from '../../../../../../schedule/components/schedule-modal/components/appointment-slot/AppointmentSlots'
import { CustomerInformation } from '../../../../../../schedule/components/schedule-modal/components/customer-information/CustomerInformation'
import { OrderDetails } from '../../../../../../schedule/components/schedule-modal/components/order-details/OrderDetails'
import { TireSizeQuantity } from '../../../../../../schedule/components/schedule-modal/components/size-quantity/TireSizeQuantity'
import { updateOrderStatusToScheduled } from '../../../../../../schedule/components/schedule-modal/components/size-quantity/api'
import { WoDetailContext } from '../../../../context/context'
import styles from '../../scheduling-modal/styles.module.css'
import { ServiceNames } from '../../../../../../global/constants/service'
import { STATUSES } from '../../../../../../global/constants/order-status'
interface IScheduleModalProps {
  isOpen: boolean
  handleClosed: Function
  route: string
  mode: string
  setModalName: Function
}

const finishFlow: Record<string, string> = {
  'Customer Information': 'Tire Size and Quantity',
  'Tire Size and Quantity': 'Appointment Slot',
  'Appointment Slot': 'Payment Information',
  'Payment Information': 'Confirm Appointment',
}

export default function ScheduleContainerModal(props: IScheduleModalProps) {
  const { data: orderData, queryOrderData } = useContext(WoDetailContext)

  const previousDisposalCount =
    orderData.orderServices.find(
      (service) => service.label === ServiceNames.TIRE_DISPOSAL,
    )?.quantity || 0
  const previousSelectedTimes = orderData.routeInstructions?.[0]?.startTime
    ? [orderData.routeInstructions[0].startTime].map((dateString) =>
        new Date(dateString).valueOf(),
      )
    : []

  if (
    !orderData.installationPoint ||
    !orderData.customer ||
    !orderData.orderVehicles[0].customerVehicle ||
    !orderData.orderVehicles[0].tiresCombination ||
    !orderData.objectId
  )
    return <></>

  const [installationPoint, setInstallationPoint] =
    useState<IInstallationPoint>(orderData.installationPoint)
  const [customer, setCustomer] = useState<ICustomer>(orderData.customer)
  const [customerVehicle, setCustomerVehicle] = useState<ICustomerVehicle>(
    orderData.orderVehicles[0].customerVehicle,
  )
  const [tiresCombination, setTiresCombination] = useState<ITiresCombination>(
    orderData.orderVehicles[0].tiresCombination,
  )
  const [disposalCount, setDisposalCount] = useState<number>(
    previousDisposalCount,
  )
  const [selectedTimes, setSelectedTimes] = useState<number[]>(
    previousSelectedTimes,
  )
  const [order, setOrder] = useState<Partial<IOrder>>(orderData)

  const [saveDisabled, setSaveDisabled] = useState(false)

  const { handleClosed, isOpen, route, mode, setModalName } = props
  const [activeButton, setActiveButton] = useState('Customer Information')
  useEffect(() => {
    setActiveButton(route)
  }, [route])

  const nextClick = async () => {
    if (mode === MODES.FINISH) {
      await ref.current.useNextClick((wasSuccessful: boolean) => {
        if (wasSuccessful) {
          setModalName(finishFlow[route])
        } else {
          alert(
            'Something unexpected happened. Please check your inputs and try again.',
          )
        }
      })
    }
  }

  const ref = useRef<any>(null)
  const saveClick = async () => {
    if (ref.current !== null) {
      await ref.current.useSaveClick()
      await queryOrderData(orderData.objectId)
    }
  }

  const goBack = () => {
    if (mode === MODES.FINISH) {
      const [nextRoute] =
        Object.entries(finishFlow).find(([, value]) => value === route) || []

      if (nextRoute) {
        setModalName(nextRoute)
      }
    } else {
      console.error('NO FLOW FOR THIS BUTTON WHEN NOT IN `FINISH` MODE')
    }
  }

  const whichPage = (activeButton: string) => {
    switch (activeButton) {
      case 'Customer Information':
        return (
          <CustomerInformation
            installationPoint={installationPoint}
            setInstallationPoint={setInstallationPoint}
            customer={customer}
            setCustomer={setCustomer}
            customerVehicle={customerVehicle}
            setCustomerVehicle={setCustomerVehicle}
            ref={ref}
            setDisabled={setSaveDisabled}
            mode={mode}
            location={orderData.location}
          />
        )
      case 'Tire Size and Quantity':
        return (
          <TireSizeQuantity
            ref={ref}
            customerVehicle={customerVehicle}
            tiresCombination={tiresCombination}
            setTiresCombination={setTiresCombination}
            disposalCount={disposalCount}
            setDisposalCount={setDisposalCount}
            setDisabled={setSaveDisabled}
            orderObjectId={orderData.objectId}
          />
        )
      case 'Appointment Slot':
        return (
          <AppointmentSlots
            ref={ref}
            selectedTimes={selectedTimes}
            setSelectedTimes={setSelectedTimes}
            setDisabled={setSaveDisabled}
            installationPoint={installationPoint}
            setInstallationPoint={setInstallationPoint}
            mode={mode}
            orderObjectId={orderData.objectId}
            locationId={orderData.location?.objectId ?? ''}
          />
        )
      case 'Order Details':
        return (
          <OrderDetails
            ref={ref}
            order={order}
            setOrder={setOrder}
            isRework={
              !!order.orderServices?.some(
                (service) => service.label === 'Rework',
              )
            }
            setDisabled={setSaveDisabled}
            mode={mode}
            installationPoint={installationPoint}
            locationId={orderData.location?.objectId ?? ''}
          />
        )
      // case 'Confirm Appointment':
      //   return (
      //     <ConfirmAppointment
      //       schedulerState={editOrderState}
      //       setSchedulerState={setEditOrderState}
      //       setDisabled={setSaveDisabled}
      //     />
      //   )
    }
  }

  const closeModalHandler = () => {
    setActiveButton('Customer Information')
    handleClosed()
  }

  const handleButtonClick = (e: any) => {
    setActiveButton(e.target.innerHTML)
  }
  const confirmClick = async () => {
    try {
      setSaveDisabled(true)
      await fetchData<IOrder>(updateOrderStatusToScheduled(orderData.objectId))
      await queryOrderData(orderData.objectId)
      handleClosed()
    } catch (error: any) {
      alert(error)
    } finally {
      setSaveDisabled(false)
    }
  }

  const displayConfirmApp =
    [STATUSES.quote, STATUSES.unconfirmed].includes(orderData.status ?? '') &&
    orderData.tireRackOrders
  return (
    <div>
      <Modal open={isOpen}>
        <Box className={styles.scheduleModal}>
          <div
            className={`${styles.scheduleModalPageTitle} font--bold`}
          >{`${activeButton}`}</div>
          <div style={{ width: '100%', overflowX: 'scroll' }}>
            {whichPage(activeButton)}
          </div>
          <div className={styles.buttonContainer}>
            {mode !== MODES.FINISH && (
              <div className={styles.pagesLinks}>
                <button
                  className={`${styles.navLink} ${
                    activeButton === 'Customer Information'
                      ? styles.active
                      : null
                  }`}
                  onClick={(e) => handleButtonClick(e)}
                >
                  Customer Information
                </button>
                <button
                  className={`${styles.navLink} ${
                    activeButton === 'Tire Size and Quantity'
                      ? styles.active
                      : null
                  }`}
                  onClick={(e) => handleButtonClick(e)}
                >
                  Tire Size and Quantity
                </button>
                <button
                  className={`${styles.navLink} ${
                    activeButton === 'Appointment Slot' ? styles.active : null
                  }`}
                  onClick={(e) => handleButtonClick(e)}
                >
                  Appointment Slot
                </button>
                <button
                  className={`${styles.navLink} ${
                    activeButton === 'Order Details' ? styles.active : null
                  }`}
                  onClick={(e) => handleButtonClick(e)}
                >
                  Order Details
                </button>
                {displayConfirmApp && (
                  <button
                    className={`${styles.navLink} ${
                      activeButton === 'Confirm Appointment'
                        ? styles.active
                        : null
                    }`}
                    onClick={(e) => handleButtonClick(e)}
                  >
                    Confirm Appointment
                  </button>
                )}
              </div>
            )}
            <div className={styles.flexButtons}>
              <div className={styles.flexGroupButtons}>
                {mode === MODES.FINISH &&
                  activeButton !== 'Confirm Appointment' && (
                    <SecondaryButton
                      buttonName='Back'
                      onClick={() => goBack()}
                    />
                  )}
                <SecondaryButton
                  buttonName='Cancel'
                  onClick={() => closeModalHandler()}
                />
              </div>
              {activeButton !== 'Confirm Appointment' ? (
                <PrimaryButton
                  buttonName={mode === MODES.FINISH ? 'Next' : 'Save Changes'}
                  disabled={saveDisabled}
                  onClick={mode === MODES.FINISH ? nextClick : saveClick}
                />
              ) : (
                <PrimaryButton
                  buttonName='Confirm'
                  disabled={saveDisabled}
                  onClick={confirmClick}
                />
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  )
}
